/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Surface_WorkflowsInputs */

const en_marketing_surface_workflows = /** @type {(inputs: Marketing_Surface_WorkflowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflows`)
};

const es_marketing_surface_workflows = /** @type {(inputs: Marketing_Surface_WorkflowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujos de trabajo`)
};

const fr_marketing_surface_workflows = /** @type {(inputs: Marketing_Surface_WorkflowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflows`)
};

/**
* | output |
* | --- |
* | "Workflows" |
*
* @param {Marketing_Surface_WorkflowsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_surface_workflows = /** @type {((inputs?: Marketing_Surface_WorkflowsInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Surface_WorkflowsInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_surface_workflows(inputs)
	if (locale === "es") return es_marketing_surface_workflows(inputs)
	return fr_marketing_surface_workflows(inputs)
});